import React from 'react';
import { BRAND_LIBRARY_DARK_TEXT_COLOR } from 'common/constants/brandLibrary';

import Paragraph from './SessionListParagraph.styles';

export default function SessionListParagraph(props) {
    return <Paragraph {...props} />;
}

SessionListParagraph.splash = {
    ...Paragraph.splash,
    defaultProps: {
        ...Paragraph.splash.defaultProps,
        styles: {
            ...Paragraph.splash.defaultProps.styles,
            fontColor: BRAND_LIBRARY_DARK_TEXT_COLOR,
            fontSize: 16,
        },
        meta: {
            ...Paragraph.splash.defaultProps.meta,
            // eslint-disable-next-line max-len
            content: 'Check-in for all sessions opens two minutes before the session start time',
        },
    },
};
